<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.SUBSIDIARY')}}</li>
                        <li data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select class="slt_white w100" v-model="rhqCd" @change="changeRhqCd()">
                                        <option v-if="rhqCdList.length > 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100" v-model="corpNo">
                                        <option v-if="corpNoList.length != 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.REPORTBY')}}</li>
                        <li data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select class="slt_white w100" v-model="reportBy" @change="refineColumns()">
                                        <option value="S">By Subsidiary</option>
                                        <option value="I">By Inquiry</option>
                                        <option value="A">By Answerer</option>
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>

                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.PERIOD')}} <em class="txt_mandatory">*</em></li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>                
                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.INQUIRY.TYPE')}}</li>
                        <li v-if="reportBy == 'I'" data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select class="slt_white w100" v-model="inquiryCd1" @change="inquiryList(2)">
                                        <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-for="item in inquiry1Codes" :key="item.CD"
                                            :value="item.CD">{{ item.CD_NAME }}</option
                                        >
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100" v-model="inquiryCd2">
                                        <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-for="item in inquiry2Codes" :key="item.CD"
                                                :value="item.CD">{{ item.CD_NAME }}</option
                                        >
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap">
                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ totalCount | numberFormat }}</em></div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    ref="GridId"
                    :columns="columns"
                    :options="options"
                    :header="gridHeader"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import qs                       from 'query-string';
import api                      from '@/service';
import axios                    from 'axios';
import moment                   from 'moment';
import { SDLUtil, DateUtil }    from '@/utils';
import SKPBreadcrumbs           from '~vb/main/SKPBreadcrumbs';
import DatePicker               from '~c/DatePicker';
import ToastGrid                from '~c/ToastGrid';
import ExcelDownloadPopup       from '~vb/common/ExcelDownloadPopup';
import StstLinkPopup            from './StstLinkPopup';

require('moment-jdateformatparser');

// 메인 목록 조회
const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaSatisIndexBySubsidiarys.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid Class renderer
class ClassRenderer {
    constructor(props) {
        let rowKey = props.rowKey;
        let colVal = props.grid.store.data.rawData[rowKey].SUBS_DISP_NM;
        let resVal = props.value;
        let aftTotal = colVal.substring(colVal.length - 5);
        const el = document.createElement('span');
        if (colVal == 'Total') {
            el.className = "subTotal";
        } else if (aftTotal == 'Total') {
//            el.className = "ftColor";
        } else if (resVal > 0) {
            el.className = "ftColor";
        }
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

// ToastGrid Tooltip renderer
class TooltipRenderer {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name : 'BySubsidiaryList',
    props : {

    },
    data() {
        return {
            isProcess: true,
            rhqCd: '',
            corpNo: '',
            inquiryCd1: '',
            inquiryCd2: '',
            reportBy: 'S',
            FROM_DATE: {},     // Start Date
            TO_DATE: {},       // End Date
            rhqCdList: [],
            corpNoList: [],
            inquiry1Codes: [],
            inquiry2Codes: [],
            searchParam: {},
            
            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            gridHeader: {
                height: 60,
                complexColumns: [
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.ANSWERSATISFACTION'),
                        name: 'mergeColumn1',
                        childNames: ['TOTAL_CNT', 'VERY_GOOD_CNT', 'GOOD_CNT', 'NORMAL_CNT', 'BAD_CNT', 'VERY_BAD_CNT', 'NO_POLL_CNT', 'SCORE']
                    }
                ]
            },
            columns : [],
            options : {
                scrollX: false,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            params:     'getParams',
            loginNo:    'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    this.rhqCd = this.rhqCdList[0].code;
//                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
//                    else                            this.rhqCd = '';
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code);
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    this.corpNo = this.corpNoList[0].code;
//                    if (this.corpNoList.length == 1) this.corpNo = this.corpNoList[0].code;
//                    else                             this.corpNo = '';
                });
            }
        },
        changeRhqCd() {
            if (this.rhqCd == '') {
                this.corpNoList = [];
                this.corpNo = '';
            } else {
                this.loadSubsiCodes(2, this.rhqCd);
            }
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.deptNo,
                        value: this.inquiryCd1,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Codes = resp.data.result.rowData;
                        if (this.inquiry1Code) this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2Codes = resp.data.result.rowData;
                    }
                });
        },
        getSearchParams() {
            const mFormat = localStorage.getItem('mDateFormat');
            let params = {
                rhqCd      : this.rhqCd,
                corpNo     : this.corpNo,
                inquiryCd1 : this.inquiryCd1,
                inquiryCd2 : this.inquiryCd2,
                reportBy   : this.reportBy,
                strDate    : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                endDate    : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
            };
            return params;
        },

        // 버튼 이벤트
        async onSearch() {
            
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';
            if (parseInt((endDate - startDate) / (24 * 60 * 60 * 1000)) > 31) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'The maximum duration of the search is one month.',
				});
                return false;
            }

            let validContents = this.registVerifyContents();
            if (validContents) {
                let params = this.getSearchParams();
                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        this.gridData = res.data.result.rowData;
                        this.totalCount = this.gridData.length;
                        this.searchParam = res.data.searchParam;

                        this.$nextTick(() => {
                            this.$refs.GridId.addRowClassName(this.totalCount-1, 'subTotal');
                            this.gridData.forEach((row, idx) => {
                                if (row.SUBS_DISP_NM.indexOf('Total') > -1) {
                                    this.$refs.GridId.addRowClassName(idx, 'subTotal');
                                }
                            });
                        });

                        this.gridKey++;
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> Grid
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;

            let blockCols = '|SUBS_DISP_NM|SCORE|';
            let row = rowData[e.rowKey];
            let value = Number(eval('row.' + colNm));
            if (value == 0) return;
            if (row.SUBS_DISP_NM == 'Total') return;
            if (blockCols.indexOf('|' + colNm + '|') > -1) return;

            let headerNm = '';
            this.columns.forEach((elm, idx) => {
                if (elm.name == colNm) {
                    headerNm = elm.header;
                    return;
                }
            });

            let anScore = '';
            if (colNm == 'TOTAL_CNT') {          anScore = 'T'; }
            else if (colNm == 'VERY_GOOD_CNT') { anScore = '5'; }
            else if (colNm == 'GOOD_CNT') {      anScore = '4'; }
            else if (colNm == 'NORMAL_CNT') {    anScore = '3'; }
            else if (colNm == 'BAD_CNT') {       anScore = '2'; }
            else if (colNm == 'VERY_BAD_CNT') {  anScore = '1'; }
            else if (colNm == 'NO_POLL_CNT') {   anScore = '';  }
            else { anScore = ''; }

            let params = this.searchParam; // 목록 조회한 매개변수들..
            params.rhqCd     = row.RHQ_CD;
            params.corpNo    = row.SUBS_CD;
            params.anScore   = anScore;
            params.dynLabel1 = SDLUtil.getMsgProp('FIELD.GLOBAL.RHQ');
            params.dynValue1 = row.RHQ_NM;
            params.dynLabel2 = SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY');
            params.dynValue2 = row.SUBS_NM;
            params.dynLabel3 = SDLUtil.getMsgProp('FIELD.GLOBAL.SATISFACTION');
            params.dynValue3 = headerNm;
            params.btnShow = true;
            params.url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/satisIndexByGBMPops.skp`;

            SDLUtil.show(
                StstLinkPopup, {
                    title: 'title',
                    pParams: params,
                    rtnUserFunc: (arg1) => {
                        console.log('arg1 ==> ', arg1);
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
        },
        // 엑셀 다운로드
        excelDownload() {
            const startDate = moment(this.rangePicker.getStartDate());
            const endDate = moment(this.rangePicker.getEndDate());
            const dateDiff = Math.abs(endDate.diff(startDate, 'days'));
            if (dateDiff > 31) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'Maximum Period range for Export to Excel is 1 month',
                });
                return;
            }

            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let param = this.getSearchParams();
                    param.colId = 'FIELD.GLOBAL.SUBSIDIARY';
                    param.colNm = 'SUBS_DISP_NM';
                    if (this.reportBy == 'I')       param.dynQueryId = 'findBySubsidiaryI';
                    else if (this.reportBy == 'A')  param.dynQueryId = 'findBySubsidiaryA';
                    else                            param.dynQueryId = 'findBySubsidiary'
                    param.excelFileName = 'SatisfactionIndexBySubsidiary';
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaSatisfactionIndexByExcel.skp`,
                            qs.stringify(param),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        // 그리드 컬럼 재정의
        refineColumns() {
            this.gridData = [];
            let cntWid = 100;
            this.columns = [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                    name: "SUBS_DISP_NM",
                    align: "left",
                    sortable: false,
                    resizable: true
                }
            ];

            if (this.reportBy == 'I') {
                cntWid = 78;
                let variCol = {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY.TYPE'),
                    name: "INQRY_TYPE_NM",
                    align: "left",
                    width: 220,
                    sortable: false,
                    renderer: {type: TooltipRenderer },
                    resizable: true
                };
                this.columns.push(variCol);
            } else if (this.reportBy == 'A') {
                cntWid = 80;
                let variCol = {
                    header: SDLUtil.getMsgProp('TITLE.GLOBAL.ANSWERERS'),
                    name: "LOGIN_NM",
                    align: "left",
                    width: 180,
                    sortable: false,
                    renderer: {type: TooltipRenderer },
                    resizable: true
                };
                this.columns.push(variCol);
            } else {
                console.log('Base Columns....');
            }

            let addCols = [
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL'),
                        name: "TOTAL_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                        resizable: true
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.VERYGOOD'),
                        name: "VERY_GOOD_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                        resizable: true
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.GOOD'),
                        name: "GOOD_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                        resizable: true
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.NORMAL'),
                        name: "NORMAL_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.BAD'),
                        name: "BAD_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.VERYBAD'),
                        name: "VERY_BAD_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.ADMIN.NO.POLL'),
                        name: "NO_POLL_CNT",
                        align: "center",
                        width: cntWid,
                        renderer: { type: ClassRenderer },
                        sortable: false,
                    },
                    {
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.SCORE'),
                        name: "SCORE",
                        align: "center",
                        width: cntWid,
                        sortable: false,
                    }
            ];

            addCols.forEach(elm => {
                this.columns.push(elm);
            });
            this.gridKey += 1;
        },
        registVerifyContents() {
            let validList = [''];
//            if (SDLUtil.isNull(this.FROM_DATE.getDate())) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
//            if (SDLUtil.isNull(this.TO_DATE.getDate()))   validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if (validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        }
    },
    created() {
        this.refineColumns();
        // 초기 카테고리1 리스트 로드
    },
    mounted() {

        // Subsidiary
        this.loadSubsiCodes(1, '');

        // Inquiry Type
        this.inquiryList(1);
		
		// Date prev => (new moment()).add(-1, 'years').toDate(), 
        this.$nextTick(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'month').toDate(),
                (new moment()).toDate()
            );
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
.ftColor { color: dodgerblue!important; font-weight: bold!important; cursor:pointer; }
.ftBold {font-weight: bold!important;}
.subTotal {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/bySubsidiaryList.vue